<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :span="6">
                <el-cascader placeholder="所属大区" @change="handleOfficeChange"
                        :options="this.area.list"
                        :props="{ checkStrictly: true }"
                        v-model="selected_office_area_id"
                        size="mini"
                        clearable>
                </el-cascader>
              </el-col>
              <el-col :span="6">
                <el-cascader size="mini" placeholder="选择标签"
                  :options="tag.list"
                  :props="{value:'tag_id', label: 'tag_name'}"
                  v-model='params.dis_tag_id'
                  clearable
                  @change="TagChangeAction">
                </el-cascader>
              </el-col>
              <el-col :span="6">
                <el-button size="mini" type="primary" @click="setMarketPrice">设置区域划线价</el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个货号之间使用英文逗号 ',' 分隔" v-model="params.item_bns" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个店铺ID之间使用英文逗号 ',' 分隔" v-model="params.inca_ids" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="item_id" label="商品ID" width="90"></el-table-column>
                <el-table-column prop="item_bn" label="商品货号" width="90"></el-table-column>
                <el-table-column prop="item_name" label="商品名称"></el-table-column>
                <el-table-column prop="number" label="店铺ID" width="90"></el-table-column>
                <el-table-column prop="name" label="店铺名称"></el-table-column>
                <el-table-column prop="market_price" label="原价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.market_price / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="area_market_price" label="区域划线价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.area_market_price / 100 }}
                  </template>
                </el-table-column>
                <!-- <el-table-column label="预计发货日期">
                    <template slot-scope="scope">
                        <span style="font-weight:600;">{{scope.row.shipdays}}</span>天后
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <div class="operating-icons">
                            <el-button @click="updatePresalePromotion(scope.row)" type="text">
                                编辑
                            </el-button>
                            <el-button @click="closePresalePromotion(scope.row)" type="text">
                                删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import {setItemAreaMarketPrice, getItemAreaMarketPrice} from '@/api/goods'
import { getAreaManageList } from "@/api/areamanage";
import { getTagList } from '@/api/marketing'
export default {
    data() {
      return {
        memberTagDialog: false,
        selected_office_area_id: [],
        form: {
          item_bn: '',
        },
        loading: false,
        params: {
          page: 1,
          pageSize: 20,
          item_bns: '',
          inca_ids: '',
          dis_tag_id: 0,
          dis_area_id: 0,
        },
        total_count: 0,
        list: [],
        tag: {
          dialog: false,
          list: [],
        },
        area: {
          dialog: false,
          list: [],
        },
      }
    },
    methods: {
      addTemplate () { // 添加商品预售
        this.memberTagDialog = true
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      addPresalePromotion() {
        this.$router.push({path: this.matchHidePage('editor')})
      },
      updatePresalePromotion(row) {
        this.$router.push({path: this.matchHidePage('editor/') + row.id})
      },
      getItemAreaMarketPrice() {
        this.loading = true
        console.log(this.params)
        getItemAreaMarketPrice(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      closePresalePromotion(row) {
        let that = this
        var msg = '预售取消前请检查商品库存查询方式'
        this.$confirm(msg, '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              deleteGoodsPresale(row.id).then(res => {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                  duration: 2 * 1000,
                  onClose() {
                    that.getPresalePromotionsLists()
                  }
                })
              })
            }
            done()
          }
        })
      },
      goodsSearch() {
        this.params.page = 1
        this.getItemAreaMarketPrice()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getItemAreaMarketPrice()
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getItemAreaMarketPrice()
      },
      // 获取大区数据
      getDataAreaManage() {
        getAreaManageList({'format_flag':true}).then(response => {
          this.params.page = 1;
          this.area.list = response.data.data;
        })
      },
      // 大区选择
      handleOfficeChange(val) {
        console.log(val);
        this.selected_office_area_id = val
        if (val.length > 1) {
          this.params.dis_area_id = val[1]
        } else {
          this.params.dis_area_id = val[0]
        }
        this.getItemAreaMarketPrice()
      },
      // 获取店铺标签数据
      getAllTagList () {
        let params = {
          page: 1,
          pageSize: 500
        }
        getTagList(params).then(response => {
          this.tag.list = response.data.data.list
        })
      },
      // 选择店铺标签
      TagChangeAction(tags) {
        this.params.dis_tag_id = tags[0]
        this.params.page = 1
        this.getItemAreaMarketPrice()
      },
      setMarketPrice() {
        this.$router.push({path: this.matchHidePage('editor')})
      }
    },
    mounted() {
      this.getItemAreaMarketPrice()
      // 获取大区数据
      this.getDataAreaManage()
      // 获取店铺标签数据
      this.getAllTagList()
    }
  }
</script>




// WEBPACK FOOTER //
// list.vue?68c6e1e6